export const accountBenefitsContent = `Welcome to Batesky! Here's what to expect about your account.

Batesky is built on Bluesky and the underlying [AT Protocol](https://atproto.com/). Your account is yours, all of your posts and connections (following & followers) belong to your account.

## Creating Your Account

1. Visit the Bluesky website: [bsky.app](https://bsky.app/) 
2. Tap **Sign Up** and enter your details
3. Complete your account setup
4. Come back to batesky.app and log in with your Bluesky account name/email and password

## Batesky Invite Codes

We are slowly rolling out invites to Batesky. If you would like an invite code please send us a Direct Message via the Bluesky Chat.

If you need further help, contact us at [support@batesky.app](mailto:support@batesky.app).
`
